import React from 'react'
import Inner from '../component/Innerbanner'

function Contactus() {
  return (
    <div>
      <Inner  name="Contact Us" title="Home . CONTACT us" />

      {/* --- Contact Form Section --- */}
      {/* We apply font-custom here to match your theme from the Service component */}
      <div className="bg-white py-16 sm:py-24 font-custom">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Form Header */}
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Drop Us A Line
          </h2>
          {/* Using text-gray-500 to match your theme's paragraph color */}
          <p className="text-sm text-gray-500 mb-8">
            Your email address will not be published. Required fields are marked *
          </p>

          {/* Form */}
          <form action="#" method="POST">
            {/* Grid for the top four inputs */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              
              {/* First Name */}
              <div>
                <label htmlFor="first-name" className="sr-only">First Name</label>
                <input
                  type="text"
                  name="first-name"
                  id="first-name"
                  placeholder="Enter Your First Name*"
                  className="w-full p-4 border border-gray-300 rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-500 transition"
                  required
                />
              </div>
              
              {/* Last Name */}
              <div>
                <label htmlFor="last-name" className="sr-only">Last Name</label>
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  placeholder="Enter Your Last Name*"
                  className="w-full p-4 border border-gray-300 rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-500 transition"
                  required
                />
              </div>

              {/* Email Address */}
              <div>
                <label htmlFor="email" className="sr-only">Email Address</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Your Email Address*"
                  className="w-full p-4 border border-gray-300 rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-500 transition"
                  required
                />
              </div>

              {/* Phone Number */}
              <div>
                <label htmlFor="phone" className="sr-only">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="Enter Your Phone Number*"
                  className="w-full p-4 border border-gray-300 rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-500 transition"
                  required
                />
              </div>
            </div> {/* End of grid */}

            {/* Message Textarea */}
            <div className="mb-6">
              <label htmlFor="message" className="sr-only">Message</label>
              <textarea
                name="message"
                id="message"
                rows="6"
                placeholder="Enter your Message*"
                className="w-full p-4 border border-gray-300 rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-500 transition"
                required
              ></textarea>
            </div>

            {/* Checkbox */}
            <div className="flex items-center gap-3 mb-8">
              <input
                id="save-info"
                name="save-info"
                type="checkbox"
                className="h-4 w-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
              />
              <label htmlFor="save-info" className="text-sm text-gray-600">
                Save my name, email, and website in this browser for the next time I comment.
              </label>
            </div>

            {/* Submit Button - Styled to match the image */}
            <div>
              <button
                type="submit"
                // Using text-teal-600 to match your theme
                className="relative inline-block font-semibold text-lg text-teal-600 group"
              >
                <span>Post A Comment</span>
                {/* This div creates the swoosh underline from the image */}
                <div 
                  className="absolute left-0 -bottom-2 w-full h-2 border-b-4 border-teal-400 
                             rounded-bl-full transform scale-x-75 origin-left
                             group-hover:scale-x-100 transition-transform duration-300 ease-out"
                ></div>
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  )
}

export default Contactus
  